import { render, staticRenderFns } from "./ProjectCustomField.vue?vue&type=template&id=31e54766&"
import script from "./ProjectCustomField.vue?vue&type=script&lang=js&"
export * from "./ProjectCustomField.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCustomField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31e54766')) {
      api.createRecord('31e54766', component.options)
    } else {
      api.reload('31e54766', component.options)
    }
    module.hot.accept("./ProjectCustomField.vue?vue&type=template&id=31e54766&", function () {
      api.rerender('31e54766', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/common/ProjectCustomField.vue"
export default component.exports